module.exports = __webpack_public_path__ + "img/graphic-6.3ab06089.png";